<div class="flex flex-col  justify-between h-full" [class.sidebar-collapsed]="collapsed">
    <div class="flex flex-col flex-1 min-h-0 min-w-0">
  <div class="flex  justify-between w-full items-center px-14 py-20 "
            [class]="collapsed?'flex-col logo-block':'flex-row logo-block1'">
            @if(collapsed ){
            <div class="logo">
                <img src="assets/images/logo_color.svg" width="35" />
            </div>
            } @else{
            <div class="logo">
                <img src="assets/images/Ceipal_Logo.svg" />
            </div>
            }
            <a class="cursor-pointer  flex leftmenu w-32 h-32 hover:bg-[var(--p-gray-300)] rounded-xs justify-center items-center"
                (click)="toggleSidebar()" [class]="collapsed?'absolute ':'relative'">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <use
                        [attr.xlink:href]="'assets/images/icon-library.svg#' + (collapsed ? 'panel-right-close' : 'panel-left-close')">
                    </use>
                </svg></a>


        </div>
        <div class="flex px-4">
            <ul class="nav-items">

                <li><a href="#" (click)="startNewChat($event)" [pTooltip]="collapsed?'New Chat ':''">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <use xlink:href="assets/images/icon-library.svg#square-pen"></use>
                        </svg> <span>New Chat</span></a></li>
                <li><a class="flex gap-8 flex-row items-center" (click)="openSearchPopup()" [pTooltip]="collapsed?'Search ':''">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                              viewBox="0 0 16 16" fill="none">
                              <use xlink:href="assets/images/icon-library.svg#search"></use>
                          </svg> <span>Search</span></a></li>
                <li><a class="flex gap-8 flex-row items-center" [pTooltip]="collapsed?'Skills ':''">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                              viewBox="0 0 16 16" fill="none">
                              <use xlink:href="assets/images/icon-library.svg#lightbulb"></use>
                          </svg> <span>Skills</span></a></li>

                @if (showWorkflowBuilder) {
                <li><a href="#" (click)="openWorkflowBuilder($event)" [pTooltip]="collapsed?'Generate Workflow ':''">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <use xlink:href="assets/images/icon-library.svg#workflow"></use>
                        </svg> <span>Generate Workflow</span></a></li>
                }
            </ul>
        </div>

        <!-- history sections: each collapses on its own, chats keep the scrolling list -->
        <div class="flex flex-col flex-1 min-h-0 min-w-0 px-4 pt-10">
          @if (!collapsed) {
          <div class="sidebar-history" [class.sidebar-history--open]="chatMenuExpanded">
            <button type="button" class="sidebar-nav-group-trigger"
              [attr.aria-expanded]="chatMenuExpanded" (click)="toggleChatMenu()">
              <span class="sidebar-nav-group-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <use xlink:href="assets/images/icon-library.svg#message-square"></use>
                </svg>
                <span>Recent Chats</span>
              </span>
              <svg class="sidebar-nav-chevron" [class.rotate-180]="chatMenuExpanded"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                <use xlink:href="assets/images/icon-library.svg#chevron-down"></use>
              </svg>
            </button>
            @if (chatMenuExpanded) {
            <div class="sidebar-history-body">
              <app-recent-chats></app-recent-chats>
            </div>
            }
          </div>

          @if (showWorkflowBuilder) {
          <div class="sidebar-history pt-12" [class.sidebar-history--open]="workflowMenuExpanded">
            <button type="button" class="sidebar-nav-group-trigger"
              [attr.aria-expanded]="workflowMenuExpanded" (click)="toggleWorkflowMenu()">
              <span class="sidebar-nav-group-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <use xlink:href="assets/images/icon-library.svg#workflow"></use>
                </svg>
                <span>Recent Workflows</span>
              </span>
              <svg class="sidebar-nav-chevron" [class.rotate-180]="workflowMenuExpanded"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                <use xlink:href="assets/images/icon-library.svg#chevron-down"></use>
              </svg>
            </button>
            @if (workflowMenuExpanded) {
            <div class="sidebar-history-body pl-12">
              <p class="sidebar-history-empty">Saved workflows will appear here.</p>
            </div>
            }
          </div>
          }
          }
        </div>
    </div>
    <div class="flex  px-8 py-10 border-t-1  border-[var(--p-gray-200)]">
        <div class="bg-[var(--p-gray-300)] h-1"></div>
        <div class="userinfo px-6 py-8 flex flex-row gap-8 w-full justify-between rounded-xs  hover:bg-[var(--p-gray-200)] cursor-pointer" (click)="menu.toggle($event)">
            <div class="flex gap-8">
                <div
                    class="w-32 h-32 font-[600] flex text-xl bg-[var(--p-gray-400)]   justify-center text-[#fff]  items-center rounded-full">
                    {{ user.userInitials() }}
                </div>
                <div class="flex flex-col detils">
                    <div class="font-[600] text-[var(--p-slate-900)] text-[13px]">{{ user.firstName() || user.displayName() }}</div>
                    <div class="font-[400] text-[var(--p-slate-900)] text-[12px]">{{ user.accountSubtitle() }}</div>
                </div>
            </div>
            <div class="flex items-center cursor-pointer menu"  >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <use xlink:href="assets/images/icon-library.svg#ellipsis"></use>
                </svg>
            </div>
        </div>
         
        <p-menu #menu styleClass="leftmenu1" [model]="moreitems" appendTo="body" [popup]="true">
            <ng-template pTemplate="start">
                <div class="p-10 text-[var(--p-slate-600)]">{{ user.userEmail() }}</div>
            </ng-template>
            <ng-template #item let-item>

                <a class="submenuitems " href="#" (click)="$event.preventDefault(); menuItemClick(item.action)">


                    <span class="flex gap-8 items-center">

                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <use [attr.xlink:href]="'assets/images/icon-library.svg#'+item.icon"></use>
                        </svg>
                        {{ item.label }}

                    </span>
                </a>

            </ng-template>
        </p-menu>
    </div>
</div>

   <p-dialog
      [(visible)]="setPopupVisible"
      (visibleChange)="onSearchDialogVisibleChange($event)"
      [modal]="true"
      [style]="{ width: '700px' }"
      styleClass="chat-search-dialog">
                <ng-template #header>
                    <div class="chat-search-dialog-title">Search</div>
                </ng-template>
                 <div class="chat-search-dialog-body formclass mb-20">
                    <div class="chat-search-controls">
                      <div class="chat-search-field">
                        
                         <div class="chat-search-bar">
                          <input
                            id="chat-search-input"
                            type="text"
                            pInputText
                            [(ngModel)]="tablesearch"
                            pSize="small"
                            (keyup.enter)="submitSearch()"
                            placeholder="Enter a title"
                            class="chat-search-input w-full h-30" />

                          @if (tablesearch || searchSubmitted) {
                          <button
                            type="button"
                            class="chat-search-clear"
                            (click)="clearSearchInput()"
                            aria-label="Clear search"
                            pTooltip="Clear search"
                            tooltipPosition="top">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                              <use xlink:href="assets/images/icon-library.svg#x"></use>
                            </svg>
                          </button>
                          }

                          <button
                            type="button"
                            class="chat-search-submit"
                            [disabled]="searchLoading"
                            (click)="submitSearch()"
                            aria-label="Search">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <use xlink:href="assets/images/icon-library.svg#search"></use>
                            </svg>
                          </button>
                         </div>
                      </div>
                    </div>
            <div class="chat-search-results-area flex pb-20 flex-col">
              @if (searchLoading) {
                <p class="px-6 py-10 text-[12px] text-[var(--p-slate-500)]">Searching…</p>
              } @else if (searchError) {
                <p class="px-6 py-10 text-[12px] text-[var(--p-red-600)]">{{ searchError }}</p>
              } @else if (!searchSubmitted) {
                <!-- <p class="px-6 py-10 text-[12px] text-[var(--p-slate-500)]">
                  Search by title, then switch tabs to view Chats or Workflows.
                </p> -->
              } @else {
                <div class="chat-search-tabs p-tabs4">
                  <p-tabs [value]="searchResultTab" (valueChange)="onSearchTabChange($event)">
                    <p-tablist>
                      <p-tab value="chats">
                        <span class="chat-search-tab-label">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                            <use xlink:href="assets/images/icon-library.svg#message-square"></use>
                          </svg>
                          Chats
                          <span class="chat-search-tab-count">{{ searchResults.length }}</span>
                        </span>
                      </p-tab>
                      @if (showWorkflowBuilder) {
                      <p-tab value="workflows">
                        <span class="chat-search-tab-label">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                            <use xlink:href="assets/images/icon-library.svg#workflow"></use>
                          </svg>
                          Workflow Builders
                          <span class="chat-search-tab-count">0</span>
                        </span>
                      </p-tab>
                      }
                    </p-tablist>
                    <p-tabpanels>
                      <p-tabpanel value="chats">
                        @if (searchResults.length) {
                        <ul class="chat-search-results">
                          @for (c of searchResults; track c.id) {
                            <li>
                              <a
                                href="#"
                                class="chat-search-result-row"
                                (click)="$event.preventDefault(); openSearchResult(c)">
                                <span
                                  #searchTitleEl
                                  class="chat-search-result-title"
                                  [pTooltip]="searchResultTitle(c)"
                                  [tooltipDisabled]="!isSearchTitleClipped(searchTitleEl)"
                                  tooltipPosition="top"
                                  tooltipStyleClass="conversation-title-tooltip">{{ searchResultTitle(c) }}</span>
                                <span class="chat-search-result-date">{{ searchResultDateLabel(c) }}</span>
                              </a>
                            </li>
                          }
                        </ul>
                        } @else {
                        <p class="chat-search-empty-group">No chats found.</p>
                        }
                      </p-tabpanel>
                      @if (showWorkflowBuilder) {
                      <p-tabpanel value="workflows">
                        <p class="chat-search-empty-group">No workflow builders found.</p>
                      </p-tabpanel>
                      }
                    </p-tabpanels>
                  </p-tabs>
                </div>
              }
            </div>
  </div>
               
            </p-dialog>

<app-usage-summary-drawer
  [visible]="usageReportVisible()"
  (visibleChange)="usageReportVisible.set($event)" />

@if (user.isAdministrator()) {
  <app-tokens-allocation-drawer
    [visible]="tokensAllocationVisible()"
    (visibleChange)="tokensAllocationVisible.set($event)" />
}

<app-ai-gallery
  [visible]="aiGalleryVisible()"
  (visibleChange)="aiGalleryVisible.set($event)" />

<app-skills-gallery
  [visible]="skillsGalleryVisible()"
  (visibleChange)="skillsGalleryVisible.set($event)" />
         